module.exports = Zepto;


//////////////////
// WEBPACK FOOTER
// external "Zepto"
// module id = 32
// module chunks = 0